/**
 * utils/format.ts — Formatadores de recursos de máquina
 * Centralizado de AgentesPage (CreateEnvironmentModal)
 */

/**
 * Formata memória RAM de Mi/Gi para GB/MB legível
 * Ex: "2048Mi" → "2 GB", "512Mi" → "512 MB"
 */
export function formatMemory(val: string): string {
  if (!val) return '-';
  
  const num = parseInt(val);
  
  // Formato "Mi" (Mebibytes)
  if (val.includes('Mi') && !isNaN(num)) {
    return num >= 1024 
      ? `${(num / 1024).toFixed(num % 1024 === 0 ? 0 : 1)} GB` 
      : `${num} MB`;
  }
  
  // Formato "Gi" (Gibibytes)
  if (val.includes('Gi')) {
    return val.replace('Gi', ' GB');
  }
  
  return val;
}

/**
 * Formata armazenamento de Gi/Mi para GB/MB legível
 * Ex: "20Gi" → "20 GB", "512Mi" → "512 MB"
 */
export function formatStorage(val: string): string {
  if (!val) return '-';
  
  // Formato "Gi" (Gibibytes)
  if (val.includes('Gi')) {
    return val.replace('Gi', ' GB');
  }
  
  // Formato "Mi" (Mebibytes)
  const mi = parseInt(val);
  if (!isNaN(mi) && val.includes('Mi')) {
    return mi >= 1024 
      ? `${(mi / 1024).toFixed(0)} GB` 
      : `${mi} MB`;
  }
  
  return val;
}

/**
 * Formata CPU de millicores para vCPU legível
 * Ex: "1000m" → "1 vCPU", "500m" → "0.5 vCPU"
 */
export function formatCpu(val: string): string {
  if (!val) return '-';
  
  const num = parseInt(val);
  
  // Formato "m" (millicores)
  if (val.includes('m') && !isNaN(num)) {
    return num >= 1000 
      ? `${(num / 1000).toFixed(0)} vCPU` 
      : `${(num / 1000).toFixed(1)} vCPU`;
  }
  
  return val;
}
